export default [
  'areaId',
  'siteId',
  'gatewayId',
  'eventTypeId',
  'readingTypeId',
  'sensorId',
  'status',
]
